ACC.formatChooserUnified = {
    _autoload: [
        ['initComponent', document.querySelectorAll('[data-component="FormatChooserUnified"]').length > 0],
    ],

    initComponent() {
        this.start(document.querySelector('.c-format-list'));
    },

    start($element) {
        this.formatList = $element;
        this.formatBlock = document.querySelector('.c-format-block');
        this.hideClass = 'isHide';
        this.activeClass = 'isActive';
        this.showClass = 'isShow';
        this.sidebaPdp = '[data-product-format]';
        this.itemClass = '.c-format-list__item';
        this.isbn = null;

        // eslint-disable-next-line no-undef
        this.pearsonDropdown = new PearsonDropdown({});
        this.initEvents();
        this.trimFormatTitle();
        this.getProductData();
        this.addControllers();
        this.toggleFormats();
        this.mobileView();
        this.arrowNavigation();
        this.bindModalPurchase();
    },

    initEvents() {
        // eslint-disable-next-line no-underscore-dangle
        const _this = this;

        if (_this.formatList) {
            _this.formatList.addEventListener('click', ACC.formatChooserUnified.formatListHandler.bind(_this));
        }

        const hasFormatBlock = document.querySelector('.c-format-block');

        if (hasFormatBlock) {
            window.addEventListener('popstate', ACC.formatChooserUnified.popstateHandler.bind(_this));
        }

        document.addEventListener('select-dropdown', (evt) => {
            ACC.formatChooserUnified.subFormatsHandler(evt);
        });
    },

    popstateHandler() {
        ACC.formatChooserUnified.getProductData();
        ACC.formatChooserUnified.toggleFormats();
    },

    subFormatsHandler(e) {
        const attr = e.target.getAttribute('data-isbn-id');
        ACC.formatChooserUnified.updateURL(attr);
    },

    formatListHandler(event) {
        // eslint-disable-next-line no-underscore-dangle
        const _this = this;
        const { target } = event;
        const forwardBlock = _this.formatList.querySelector('.c-format-list__forward');
        const forwardClass = 'c-format-list__forward-button';
        const backClass = 'c-format-list__back-button';

        if (target.parentElement.classList.contains(this.activeClass)) { return; }

        let nextElement;
        // eslint-disable-next-line max-len
        const isControlBtn = !target.classList.contains(forwardClass) && !target.classList.contains(backClass);
        if (forwardBlock) {
            nextElement = forwardBlock.nextElementSibling;
        }

        if (isControlBtn && !target.parentElement.classList.contains(this.activeClass)) {
            ACC.unifiedPDPdataLayer.updateDefaultProduct(target);
            // eslint-disable-next-line max-len
            ACC.formatChooserUnified.updateURL(target.closest('.c-format-list__item').getAttribute('data-first-product'));
        }

        if (target.classList.contains(forwardClass)) {
            ACC.formatChooserUnified.updateURL(nextElement.getAttribute('data-first-product'));
            ACC.formatChooserUnified.showMoreButtonHandler.call(_this);
            ACC.unifiedPDPdataLayer.pushShowProductOptionsEvent();
            ACC.formatChooserUnified.findSelectedButton(nextElement).focus();
        }

        if (target.classList.contains(backClass)) {
            ACC.formatChooserUnified.updateURL(this.formatList.children[0].getAttribute('data-first-product'));
            ACC.formatChooserUnified.backButtonHandler.call(_this);
            ACC.unifiedPDPdataLayer.pushShowProductOptionsEvent();
            ACC.formatChooserUnified.findSelectedButton(this.formatList.children[0]).focus();
        }
    },

    addControllers() {
        // eslint-disable-next-line no-underscore-dangle
        const _this = this;
        if (_this.formatList !== null && window.matchMedia('(min-width: 1025px)').matches) {
            const formatItem = _this.formatList.children;
            if (formatItem.length > 3) {
                formatItem[1].insertAdjacentHTML('afterend', ''
                    + '<li class="c-format-list__item c-format-list__forward">'
                    // eslint-disable-next-line max-len
                    + '    <button class="c-format-list__forward-button" tabindex="-1" aria-label="See more formats">See more formats</button>'
                    + '</li>');
                formatItem[formatItem.length - 1].insertAdjacentHTML('afterend', ''
                    + '<li class="c-format-list__item c-format-list__return">'
                    + '    <button class="c-format-list__back-button" tabindex="-1" aria-label="Return"></button>'
                    + '</li>');
            }
            if (formatItem.length === 6) {
                const cloneFormat = formatItem[1].cloneNode(true);
                document.querySelector('.c-format-list__forward').insertAdjacentElement('afterend', cloneFormat);
                cloneFormat.classList.add('c-format-list__item--clone');
            }
        }
    },

    toggleFormats() {
        // toggle page on format chooser depend on active item index
        let format;
        // eslint-disable-next-line no-underscore-dangle
        const _this = this;
        const productElement = document.getElementById(_this.isbn);
        if (productElement) {
            const activeSidebar = productElement.closest(_this.sidebaPdp);
            format = activeSidebar.getAttribute('data-product-format');
        }

        document.querySelectorAll(_this.itemClass).forEach((item, index) => {
            if (item.dataset.id === format) {
                if (index >= 3) {
                    ACC.formatChooserUnified.showMoreButtonHandler.call(_this);
                } else {
                    ACC.formatChooserUnified.backButtonHandler.call(_this);
                }
            }
        });
    },

    showMoreButtonHandler() {
        // eslint-disable-next-line no-underscore-dangle
        const _this = this;
        const firstStep = document.querySelectorAll(`${_this.itemClass}:nth-child(-n+3)`);
        const secondStep = document.querySelectorAll(`${_this.itemClass}:nth-child(n+4)`);

        firstStep.forEach((item) => {
            ACC.formatChooserUnified.toggleClass(item, _this.hideClass, _this.showClass);
        });
        secondStep.forEach((item) => {
            ACC.formatChooserUnified.toggleClass(item, _this.showClass, _this.hideClass);
        });
    },

    backButtonHandler() {
        // eslint-disable-next-line no-underscore-dangle
        const _this = this;
        const firstStep = document.querySelectorAll(`${_this.itemClass}:nth-child(-n+3)`);
        const secondStep = document.querySelectorAll(`${_this.itemClass}:nth-child(n+4)`);

        firstStep.forEach((item) => {
            ACC.formatChooserUnified.toggleClass(item, _this.showClass, _this.hideClass);
        });
        secondStep.forEach((item) => {
            ACC.formatChooserUnified.toggleClass(item, _this.hideClass, _this.showClass);
        });
    },

    toggleClass(elem, addClass, removeClass) {
        elem.classList.add(addClass);
        elem.classList.remove(removeClass);
    },

    updateURL(activeISBN) {
        this.isbn = activeISBN;
        window.history.pushState(null, null, this.isbn);
        $('.container--pdp').after($('.product-formats-included--pearsonplus-enabled'));
        ACC.formatChooserUnified.getProductData();
    },

    getProductData() {
        // eslint-disable-next-line no-underscore-dangle
        const _this = this;
        const host = window.location.href.split('?')[0];
        const programCode = $('#programDataContainer').attr('data-program-code');
        // eslint-disable-next-line prefer-destructuring
        this.isbn = host.match(/\d{13}/)[0];
        const url = `${ACC.config.contextPath}/p/details?productCode=${this.isbn}&programCode=${programCode}`;

        ACC.formatChooserUnified.setActiveProduct();

        $.get(url, (response) => {
            $('.authors-block').html($(response).closest('.product-authors'));
            $('.photo-block').html($(response).closest('.thumbnail-box'));
            $('.tabs-block').html($(response).closest('.learnerProgramDetailsPageTabs'));
            $('.product-summary__publish').before($('.product-formats-included--pearsonplus-enabled'));

            const crossCell = $(response).find('.container__cross-sell').parent();
            crossCell.find('.js-c-collection').removeClass('js-c-collection').addClass('js-unified-collection');
            // eslint-disable-next-line no-undef
            _this.Accordion = new AccordionPlugin();
            $('.cross-sell-component').html(crossCell);
            // eslint-disable-next-line no-undef
            _this.CarouselComponent = new CarouselPlugin($('.js-unified-collection'));
            const dataLayerDetails = JSON.parse($(response).closest('#dataLayerDetails').html());
            ACC.unifiedPDPdataLayer.updateDataLayer(dataLayerDetails);
            // eslint-disable-next-line no-undef
            _this.ShowMore = new ShowMore();

            ACC.formatChooserUnified.initComponentsAfterLoad();
        });
    },

    setActiveProduct() {
        let format;
        let activeFormat;
        let select;
        let activeSelectItem;
        // eslint-disable-next-line no-underscore-dangle
        const _this = this;
        const hiddenClass = 'hidden';
        const productElement = document.getElementById(_this.isbn);
        if (productElement) {
            const activeSidebar = productElement.closest(_this.sidebaPdp);
            format = activeSidebar.getAttribute('data-product-format');
            activeFormat = document.getElementById(format);
            select = activeSidebar.querySelector('.c-select');
        }

        // set active option in select
        if (select) {
            // eslint-disable-next-line prefer-destructuring
            activeSelectItem = document.querySelectorAll('[data-isbn-id="'.concat(_this.isbn, '"]'))[0];
            this.pearsonDropdown.setActiveItem(activeSelectItem);
        }
        // set active format chooser
        if (activeFormat) {
            document.querySelectorAll(_this.itemClass).forEach((item) => {
                if (item.dataset.id === format) {
                    item.classList.add(_this.activeClass);
                    if (ACC.formatChooserUnified.findSelectedButton(item)) {
                        // eslint-disable-next-line max-len
                        ACC.formatChooserUnified.setAttributes(ACC.formatChooserUnified.findSelectedButton(item), { 'aria-selected': 'true', tabindex: '0' });
                    }
                } else {
                    item.classList.remove(_this.activeClass);
                    if (ACC.formatChooserUnified.findSelectedButton(item)) {
                        // eslint-disable-next-line max-len
                        ACC.formatChooserUnified.setAttributes(ACC.formatChooserUnified.findSelectedButton(item), { 'aria-selected': 'false', tabindex: '-1' });
                    }
                }
            });
        }

        // set active sidebar
        document.querySelectorAll(_this.sidebaPdp).forEach((item) => {
            if (item.getAttribute('data-product-format') === format) {
                item.classList.remove(hiddenClass);
            } else {
                item.classList.add(hiddenClass);
            }
        });
        // set active sub format
        document.querySelectorAll('.c-sidebar-pdp__sub-format, .product-formats-included').forEach((item) => {
            if (item.id === _this.isbn) {
                item.classList.remove(hiddenClass);
            } else {
                item.classList.add(hiddenClass);
            }
        });
        // set active pdh data
        document.querySelectorAll('.js-product-pdh').forEach((item) => {
            if (item.dataset.pdhIsbn === _this.isbn) {
                item.classList.remove(hiddenClass);
            } else {
                item.classList.add(hiddenClass);
            }
        });
    },

    /**
     * Find selected button
     @private
     @param {Element} item Html element
     */
    findSelectedButton(item) {
        return item.querySelector('.c-format-list__format');
    },

    /**
     * Set additional attributes
     @private
     @param {Element} el element
     @param {Object} attrs
     */
    setAttributes(el, attrs) {
        // eslint-disable-next-line guard-for-in,no-restricted-syntax
        for (const key in attrs) {
            el.setAttribute(key, attrs[key]);
        }
    },

    trimFormatTitle() {
        const titles = document.querySelectorAll('.c-format-list__item-title');

        titles.forEach((title, index) => {
            if (title.textContent.match(/ \w+/)) {
                const maxLengthOfTitle = 18;
                const formattedTitle = title.innerText.substring(0, maxLengthOfTitle);
                const lastSpace = formattedTitle.lastIndexOf(' ');
                titles[index].innerText = title.innerText.substring(0, lastSpace);
            }
        });
    },

    initComponentsAfterLoad() {
        // this.pearsonDropdown.init();
        ACC.productThumbnail.initComponent();
        // eslint-disable-next-line no-undef,no-new
        new PearsonTabs({
            // Tabs component wrapper class
            tabsWrapperClass: '.c-tabs-wrapper',
            // List of tabs class
            tabButtonWrapperClass: '.c-tabs-list',
            // Wrapper for list class
            tabListWrapperClass: '.c-tabs-list__wrapper',
            // Arrow left class of carousel
            arrowLeftClass: '.scroller-left',
            // Arrow right class of carousel
            arrowRightClass: '.scroller-right',
            // Tab button class
            tabButtonClass: '.c-tab',
            // Tab content wrapper class
            tabContentClass: '.c-tabs-content__wrapper',
            // Class of active tab
            tabButtonActiveClass: '.current-tab',
            // Class of active tab's content
            tabContentActiveClass: '.current-tab-content',
            // Tab course expert button class
            tabCourseExpertButtonClass: '.c-expert-btn',
        });
    },

    mobileView() {
        // eslint-disable-next-line no-underscore-dangle
        const _this = this;
        let blurLeftClass;
        let blurRightClass;
        let moveLeftSide;
        let moveRightSide;
        let noScrollState;
        let marginState;
        let formatItems;
        let activeItem;
        let listWidth;
        if (_this.formatList !== null && window.matchMedia('(max-width: 767px)').matches) {
            blurLeftClass = 'opacityLeft';
            blurRightClass = 'opacityRight';
            moveLeftSide = 'moveLeft';
            moveRightSide = 'moveRight';
            noScrollState = 'noneScroll';
            marginState = 'marginLeftRight';
            formatItems = document.querySelectorAll('.c-format-list__item');
            activeItem = document.querySelector('.c-format-list__item.isActive');
            listWidth = 0;

            _this.formatList.scrollLeft = activeItem.offsetLeft;

            [].forEach.call(formatItems, (item) => {
                listWidth += item.clientWidth;
            });

            if ((_this.formatBlock.clientWidth + 30) >= listWidth) {
                _this.formatList.classList.add(noScrollState);
                return;
            }
            if ((_this.formatBlock.clientWidth + 30) < listWidth) {
                _this.formatBlock.classList.add(blurRightClass);
                _this.formatBlock.classList.add(marginState);
                _this.formatList.classList.add(moveLeftSide);

                _this.formatList.addEventListener('scroll', function () {
                    const position = Math.round(this.scrollLeft);
                    _this.formatList.classList.remove(moveLeftSide);

                    if (position === 0) {
                        _this.formatBlock.classList.add(blurRightClass);
                        _this.formatBlock.classList.remove(blurLeftClass);
                        _this.formatList.classList.add(moveLeftSide);
                        _this.formatList.classList.remove(moveRightSide);
                    } else {
                        const maxRight = this.scrollWidth - this.parentElement.clientWidth;
                        if (position === maxRight) {
                            _this.formatBlock.classList.add(blurLeftClass);
                            _this.formatBlock.classList.remove(blurRightClass);
                            _this.formatList.classList.add(moveRightSide);
                            _this.formatList.classList.remove(moveLeftSide);
                        } else {
                            _this.formatBlock.classList.add(blurRightClass);
                            _this.formatBlock.classList.add(blurLeftClass);
                            _this.formatList.classList.remove(moveLeftSide);
                            _this.formatList.classList.remove(moveRightSide);
                        }
                    }
                });
            }
            _this.formatList.addEventListener('click', () => {
                const scrollElement = document.querySelector(`${_this.itemClass}.${_this.activeClass}`);
                // eslint-disable-next-line max-len
                _this.formatList.scrollLeft = scrollElement.offsetLeft - (_this.formatList.clientWidth - scrollElement.clientWidth) / 2;
                // it is necessary to trigger the handler for touchmove,
                // in order to blur sides and blurring will work both at scrolling
                // and at transition on elements by clicks
                const event = new Event('scroll');
                _this.formatList.dispatchEvent(event);
            });
        }
    },

    /**
     * Get Focusable Elements
     @private
     @param {Element} tabList Html element
     */
    getFocusableElements(tabList) {
        const tabbedList = tabList.querySelectorAll('.c-format-list__item .c-format-list__format');
        const { filter } = Array.prototype;
        return filter.call(tabbedList, (listItem) => listItem);
    },

    /**
     * Change focus with arrows (left and right)
     @private
     */
    arrowNavigation() {
        if (this.formatList == null || this.formatList.children == null) {
            return;
        }
        // eslint-disable-next-line no-underscore-dangle
        const _this = this;
        const tabs = _this.formatList.children;
        [].forEach.call(tabs, (tab) => {
            tab.addEventListener('keyup', (event) => {
                const firstTab = ACC.formatChooserUnified.getFocusableElements(_this.formatList)[0];
                // eslint-disable-next-line max-len
                const lastTab = ACC.formatChooserUnified.getFocusableElements(_this.formatList)[ACC.formatChooserUnified.getFocusableElements(_this.formatList).length - 1];
                const showMoreButton = (_this.formatList).querySelector('.c-format-list__forward-button');
                const backButton = (_this.formatList).querySelector('.c-format-list__back-button');
                // eslint-disable-next-line max-len
                const secondStep = showMoreButton !== null ? ACC.formatChooserUnified.getFocusableElements(_this.formatList)[2] : undefined;

                if (event) {
                    const { parentNode } = event.target;

                    if (event.key === 'ArrowRight' || event.key === 'Right') {
                        if (event.target === showMoreButton) {
                            firstTab.focus();
                        } else if (event.target === backButton) {
                            secondStep.focus();
                        } else if (event.target === lastTab && showMoreButton !== null) {
                            backButton.focus();
                        } else if (event.target === lastTab && showMoreButton === null) {
                            firstTab.focus();
                        } else {
                            parentNode.nextElementSibling.firstElementChild.focus();
                        }
                    }

                    if (event.key === 'ArrowLeft' || event.key === 'Left') {
                        if (event.target === backButton) {
                            lastTab.focus();
                        } else if (event.target === secondStep && secondStep !== undefined) {
                            backButton.focus();
                        } else if (event.target === showMoreButton) {
                            parentNode.previousElementSibling.firstElementChild.focus();
                        } else if (event.target === firstTab && showMoreButton !== null) {
                            showMoreButton.focus();
                        } else if (event.target === firstTab && showMoreButton === null) {
                            lastTab.focus();
                        } else {
                            parentNode.previousElementSibling.firstElementChild.focus();
                        }
                    }

                    if (event.key === 'Home') {
                        // eslint-disable-next-line max-len
                        if (firstTab.parentElement.classList.contains(_this.hideClass) && showMoreButton !== null) {
                            secondStep.focus();
                        } else {
                            firstTab.focus();
                        }
                    }

                    if (event.key === 'End') {
                        // eslint-disable-next-line max-len
                        if (lastTab.parentElement.classList.contains(_this.hideClass) && showMoreButton !== null) {
                            showMoreButton.focus();
                        } else {
                            lastTab.focus();
                        }
                    }
                }
            });
        });
    },

    bindModalPurchase() {
        const buttonPDP = document.querySelector('.sidebar-pdp__btn');
        const buttonPDPPrintTabPopup = document.querySelector('.sidebar-pdp__btn-popup');

        if (buttonPDP) {
            ACC.formatChooserUnified.bindModalWindow(buttonPDP);
        }

        if (buttonPDPPrintTabPopup) {
            ACC.formatChooserUnified.bindModalWindow(buttonPDPPrintTabPopup);
        }
    },

    bindModalWindow(button) {
        button.addEventListener('click', (e) => {
            e.preventDefault();

            $modal.open(null, {
                inline: true,
                href: '#popup_purchase',
                className: 'popup-purchase',
            });
            ACC.subscriptionItems.init();
        });
    },
};
